<template>
  <div>
    <v-select
      v-model="document_type"
      :items="mappedDocumentTypes"
      :label="label"
      @input="getSelected"
      multiple
      :menu-props="{ top: true, offsetY: true }"
      item-text="name"
      item-value="id"
    ></v-select>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  export default {
    props: {
      label: String,
      resetValues: Boolean
    },
    data: () => ({
      document_type: [],
    }),
    methods: {
      getSelected() {
        this.$emit("input", this.document_type);
      },
    },
    computed: {
      ...mapState({
        types: (state) => state.document_types.document_types,
      }),
      mappedDocumentTypes() {
        return this.types;
      },
    },
    watch: {
      resetValues: {
        handler() {
          // console.log(this.resetValues)
          this.document_type = []
        }
      }
    }
  };
</script>
